module.exports = __webpack_public_path__ + "media/img/axis/PW000-83b306479f909566a940d1fb393cd431.png";